<template>
  <el-dialog
    :visible.sync="dialogVisible"
    @close="dialogVisible = false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="489px"
    height="390px"
    :title="title"
  >
    <el-row type="flex">
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        :class="{ 'el-form-login': isLogin }"
      >
        <el-form-item prop="phone" v-if="!defaultPhone">
          <el-input v-model="form.phone" placeholder="请输入手机号码">
            <el-select
              v-model="form.countryCode"
              slot="prepend"
              placeholder="请选择"
            >
              <el-option label="+86" value="86"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input 
          v-model="form.code" 
          placeholder="请输入手机验证码"
          :maxlength="6"
          >
            <el-button
              slot="append"
              :disabled="form.send"
              class="btn-send-code"
              @click="handleSendCode"
              >{{ content }}</el-button
            >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input 
          v-model="form.imgCode" 
          placeholder="请输入验证码"
          :maxlength="4"
          >
            <template #append >
              <el-row type="flex" align="middle" class="suffix-code">
                <div class="img">
                  <img
                    :src="form.codeUrl"
                    @click="getCode"
                    class="login-code-img"
                  />
                </div>
                <div class="text-code" @click="getCode"></div>
              </el-row>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item
          prop="isAgree"
          v-if="!disableProtocol"
          :rules="isLogin ? rules.isAgree : []"
          label-width="0"
          :class="{ 'text-login': isLogin, 'text-register': isRegister }"
        >
          <el-row type="flex" class="text">
            <el-radio
              v-model="form.radio"
              label=""
              @click.native.prevent="onRadioChange('')"
              ></el-radio
            >我已阅读并同意上汽招聘<span class="text-hyperlink pointer" @click="$utils.previewPdf(`../${publicPath}上汽招聘用户服务协议20220818.pdf`)"
                >用户协议</span
              >和<span class="text-hyperlink pointer" @click="$utils.previewPdf(`../${publicPath}上汽招聘隐私政策20220818.pdf`)">隐私政策</span>
          </el-row>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row type="flex" justify="center">
      <el-button
        :disabled="isSubmit"
        type="primary"
        @click="handleLogin"
        class="btn"
        >{{submitBtnText}}</el-button
      >
    </el-row>
  </el-dialog>
</template>

<script>
import { registerAndLoginRules as rules } from "@/utils/validator";
import base64 from "@/utils/base64";
import cryptoJS from "@/utils/crypto-js";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type:String,
      default:'登录',
    },
    defaultPhone:String,
    disableProtocol:Boolean,
    submitBtnText:{
      type:String,
      default:'登录',
    },
    customSubmitHandler:Function,
  },

  data() {
    return {
      formType: this.type,
      isSubmit: false,
      isShowConfirm: true,
      content: "发送验证码",
      totalTime: 60,
      form: {
        countryCode: "86",
        phone: "",
        code: "",
        isAgree: "",
        send: false,
        radio: "-1",
        codeUrl: "",
        imgCode: "",
        uuid: "",
      },
      rules,
    };
  },
  created() {
    this.getCode();
  },
  computed: {
    publicPath() {
      return process.env.BASE_URL
    },
    dialogVisible: {
      get({ visible }) {
        return visible;
      },
      set(val) {
        this.$emit('update:visible',val)
        this.$store.commit("form/SET_SHOW_LOGIN", val);
      },
    },
    isRegister({ formType }) {
      return formType === "register";
    },
    isLogin({ formType }) {
      return formType === "login";
    },
    phone({form,defaultPhone}){
      return defaultPhone?defaultPhone:form.phone
    }
  },

  methods: {
    async getCode() {
      let { success, code, msg, data } = await this.$api.getImgCode({});
      // console.log("data", data);
      if (success) {
        this.form.codeUrl = "data:image/gif;base64," + data.img;
        this.form.uuid = data.uuid;
      }
    },
    onRadioChange(e) {
      // 当点击已经选中的把 radio 置空，就是取消选中，并返回
      if (this.form.radio === e) {
        this.form.radio = "-1";
        this.isShowConfirm = true;
        return;
      }
      // 不是选中，选中当前点击 Radio
      this.form.radio = e;
      this.isShowConfirm = false;
    },

    // 注册
    async handleRegister() {
      try {
        await this.$refs.form.validate();
      } catch (err) {
        console.error(err);
      }
    },
    // 登录
    async handleLogin() {
      try {
        await this.$refs.form.validate();

        let phone = this.phone;
        let curCode = this.form.code;
        let imgCode = this.form.imgCode;
        let uuid = this.form.uuid;
        if (!curCode || String(curCode).length != 6) {
          this.$message({
            type: "error",
            message: "请输入正确的验证码",
          });
          return;
        }
        if (!imgCode || String(imgCode).length != 4) {
          this.$message({
            type: "error",
            message: "请输入正确的验证码",
          });
          return;
        }
      
        if (this.isShowConfirm && !this.disableProtocol) {
          this.$message({
            type: "error",
            // title: " 投递提醒",
            message: `请阅读并同意上汽招聘用户协议和隐私政策`,
          });
          return;
        }
        if (phone && curCode && imgCode && uuid) {
          let encodePhone = cryptoJS.encrypt(new base64().encode(phone));
          //506526
          //13296553193
          let customSubmitHandler = this.customSubmitHandler;
          let params = {
            code: curCode,
            phone: encodePhone,
            uuid: uuid,
            imgCode: imgCode,
          }
          if (customSubmitHandler) {
            customSubmitHandler(params);
          } else {
          let { success, code, msg, data } = await this.$api.phoneLogin(params);
          if (success) {
            console.log("登陆成功", success, code, msg);
            let token = data.token;
            let userInfo = { phone };
            if (token) {
              this.$store.commit("user/SET_PWD_STATUS", "changed");
              this.$store.commit("user/SET_TOKEN", token);
              this.$store.commit("user/SET_ROLE", [
                this.$roleEnum.CANDIDATE.name,
              ]);
              this.$store.commit("user/SET_USER_INFO", userInfo);
              this.$store.commit("user/SET_ROUTES", null);
              this.$router.push("/");
            }
            this.dialogVisible = false;
            this.$message({
              type: "success",
              message: msg,
            });
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
            this.$router.push("/collegeRecruit");
          }
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    async countDown() {
      this.content = this.totalTime + "s后重新发送"; //这里解决60秒不见了的问题
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + "s后重新发送";
        if (this.totalTime < 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(clock);
          this.content = "重新发送验证码";
          this.totalTime = 60;
        }
      }, 1000);
    },
    // 发送验证码
    async handleSendCode() {
      // await this.$refs.form.validate();
      let val = true;
      try {
        await this.$refs.form.validate("phone");
        // await this.$refs.form.validate("code");
      } catch (err) {
        val = false;
      }
      console.log("xx", val);
      if (!val) {
        return;
      }
      if (this.totalTime < 60) {
        // console.log("time",this.totalTime)
        return;
      }
      this.content = this.totalTime + "s后重发"; //这里解决60秒不见了的问题
      this.form.send = true;
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + "s后重发";
        if (this.totalTime < 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(clock);
          this.content = "发送验证码";
          this.form.send = false;
          this.totalTime = 60;
        }
      }, 1000);
      let phone = this.phone;
      if (phone) {
        phone = cryptoJS.encrypt(new base64().encode(phone));
        console.log("xxx", phone);
        let { success, code, msg } = await this.$api.sendSms({
          phone,
        });
        if (success) {
          console.log("发送成功", success, code, msg);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
   border-radius: 10px;    /*输入框圆角值*/
  .el-dialog__header {
    padding-bottom: 22px;
    .el-dialog__title {
      color: #000;
      font-weight: 600;
    }
    .el-dialog__headerbtn {
      .el-dialog__close {
        &::before {
          @extend .f18;
          color: rgba(0, 0, 0, 0.65);
        }
      }
    }
  }
  .el-dialog__body {
    padding: 0 30px 41px;
    .el-form {
      &-login {
        .el-input__inner {
          padding-left: 0;
        }
      }
      .el-form-item__label {
        @extend .f18;
        color: #323233;
      }
      .el-form-item__content {
        .el-input-group__prepend{
          border: none;
        }
        .el-input-group__append {
          border: none;
          background: transparent;
        }
        .el-select {
          width: 76px;
          color: #000;
        }
        .el-input__inner {
          @extend .f18;
          color: #000;
          border: none;
        }
        .el-input-group__prepend {
          &::after {
            content: "";
            display: inline-block;
            position: relative;
            left: 20px;
            width: 1px;
            height: 27px;
            background: #ebeef5;
            vertical-align: middle;
          }
        }

        .btn-send-code {
          padding: 0;
          width: 90px;
          height: 32px;
          border-radius: $border-radius;
          color: #409eff;
          border: 1px solid #409eff;
        }
        .suffix-code {
          height: 100%;
          .img {
            margin-right: 20px;
            width: 110px;
            height: 45px;
            img {
              width: 100%;
              height: 100%;
              border-radius: $border-radius;
            }
          }
          .text-code {
            width: 20px;
            height: 20px;
            background: url("~@/assets/icon/refresh_2.png") center/100% no-repeat;
            font-size: 18px;
            color: #409eff;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.text {
  line-height: 1;
  color: #323233;
  &-register {
    margin: 41px 0 40px;
  }
  &-login {
    margin: 16px 0 2px;
    .btn-register {
      padding: 0;
      @extend .f18;
      line-height: 1;
    }
  }
  .el-radio {
    margin-right: 0;
  }
  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: initial;
  }
  .el-radio__label {
    padding-left: 8px;
  }
  &-hyperlink {
    margin-bottom: 40px;
    color: #409eff;
  }
}
.btn {
  width: 429px;
  height: 48px;
  background: #1890ff;
  border-radius: $border-radius;
}
.login-code-img {
  width: 100px;
  height: 45px;
  // margin-bottom: 0%;
  // margin-left: 0%;
}
</style>
